import { useState } from "react";
import * as React from "react";
import Form from "../../../components/Form"; // Custom Form component
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { loginVendor } from "../../../utils/api/vendorLogin";

interface Field {
  type?: "text" | "password" | "select";
  name: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  options?: { label: string; value: string }[];
}

const SignIn: React.FC = () => {
  // State for form data
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  // React Query mutation for login
  const mutation = useMutation({
    mutationFn: loginVendor, // Function to call login API
    onSuccess: (data: any) => {
      if (data?.token) {
        // Store the token in localStorage
        localStorage.setItem("authToken", data.token);

        // Display success message
        toast.success("Logged in successfully!");

        // Optional: Redirect or perform post-login actions
        console.log("Token:", data.token);
      } else {
        toast.error("Unexpected response from server.");
      }
    },
    onError: (error: any) => {
      const response = error.response?.data;
      const errorMessage =
        response?.message || "An unknown error occurred. Please try again.";

      // Display error message
      toast.error(errorMessage);

      // Log error for debugging
      console.error("Error Response:", response);
    },
  });

  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate(formData); // Trigger the mutation
  };

  // Define the form fields
  const fields: Field[] = [
    {
      type: "text",
      name: "username",
      placeholder: "Enter your username",
      value: formData.username,
      onChange: handleChange,
    },
    {
      type: "password",
      name: "password",
      placeholder: "Enter your password",
      value: formData.password,
      onChange: handleChange,
    },
  ];

  return (
    <div className="App mt-10 mb-14">
      <Form
        title="Login"
        fields={fields}
        buttonLabel="Login"
        onSubmit={handleSubmit}
        className="max-w-md mx-auto shadow-lg p-6 bg-white rounded-md"
      />
    </div>
  );
};

export default SignIn;
